export const yours = {
  notLoggedInMessage: {
    title: 'Todavía no tenés ningún objeto',
    body: '¡Programá un retiro en tu domicilio de aquellos objetos que ya no usás y los guardaremos con mucho cuidado!',
    costsButton: 'Costos de almacenaje',
    signupButton: 'Cotizar',
  },
  noObjectsMessage: {
    title: 'No hay ítems en tu catálogo',
    body: '¡Programá un retiro en tu domicilio de aquellos objetos que ya no usás y los guardaremos con mucho cuidado!',
    depositButton: 'Cotizar',
    costsButton: 'Costos de almacenaje',
    title2: '¿Ya pediste tu retiro?',
    body2: 'Asegurate de tener tus cosas correctamente preparadas para que puedan entrar al depósito. Te dejamos nuestra Guía de Almacenamiento:',
    storageGuideButton: 'Ir a la guía',
  },
  depositButton: 'Cotizar',
  shareButton: 'Compartir',
  loadMore: 'Cargar más',
}



// WEBPACK FOOTER //
// ./src/sections/yours/text.js